import { AuditMatchCategoryNavigator } from '../../components/AuditMatchCategoryNavigator';
import { MatchCategory } from '../matches-list/types';
import { MentionsIndexView } from './components/mentions-index/MentionsIndexView';
import { SchedulesMentionsListView } from './components/mentions/SchedulesMentionsListView';
import { SchedulesSpotListView } from './components/spot/SchedulesSpotListView';
import { Station } from '@app/core/types/stations';

export function SchedulesRootView({ station }: { station: Station }) {
  return (
    <div>
      <AuditMatchCategoryNavigator
        additionalCategories={[
          {
            id: 'pnt-index',
            label: 'MENTIONS (INDEX)',
            path: 'pnt-index',
          },
        ]}
      >
        {(category) =>
          category === MatchCategory.ADS ? (
            <SchedulesSpotListView station={station} />
          ) : category === MatchCategory.LIVE_MENTIONS ? (
            <SchedulesMentionsListView station={station} />
          ) : (
            <MentionsIndexView station={station} />
          )
        }
      </AuditMatchCategoryNavigator>
    </div>
  );
}
